import { APIClient } from "./apiCore";
import * as url from "./urls";

const api = new APIClient();


// 배너 리스트 조회
export const postCommBannerList = (data) =>
    api.create(url.POST_COMM_BANNER_LIST, data);